import React from 'react';
import { DatePicker } from '@fourthwall/components';
import { useShopTime } from '../providers/ShopTimeProvider';
import { addTimezoneAbbreviationToLabels } from '../utils/addTimezoneAbbreviationToLabels';
import { convertDateToLocalDate } from '../utils/convertDateToLocalDate';
import { convertDateToUTC } from '../utils/convertDateToUTC';
export const TimezonedDatePicker = ({ value, labels = ['Starts', 'Ends'], timeLabels = ['Start time', 'End time'], onChange, minDate, maxDate, ...props }) => {
    const { timezoneAbbreviation, formatInShopTime, toUTC } = useShopTime();
    const convertValuesToLocalDate = (value) => {
        if (!value)
            return [];
        return value
            .filter((date) => date !== undefined)
            .map((date) => convertDateToLocalDate(date, formatInShopTime));
    };
    const handleChange = (changedValue) => {
        if (!onChange)
            return;
        onChange(changedValue.map((date) => convertDateToUTC(date, toUTC)));
    };
    const getInitialTimeValues = () => {
        if (value?.some((item) => item !== undefined))
            return;
        if (!props.showTimeInputs)
            return;
        const currentLocalTime = formatInShopTime(new Date(), 'hh:mm A');
        return props.type === 'range' ? [currentLocalTime, currentLocalTime] : [currentLocalTime];
    };
    return (React.createElement(DatePicker, { ...props, value: convertValuesToLocalDate(value), labels: addTimezoneAbbreviationToLabels(labels, timezoneAbbreviation), timeLabels: addTimezoneAbbreviationToLabels(timeLabels, timezoneAbbreviation), initialTimeValues: getInitialTimeValues(), minDate: convertDateToLocalDate(minDate, formatInShopTime), maxDate: convertDateToLocalDate(maxDate, formatInShopTime), onChange: handleChange }));
};
